//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Die.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/Section.js";
import "../Die/Die.DiePlaneBuilder.js";
import "../no/Expression.js";
import "../no/SelectCartesianCoordinateSystem.js";
import "../Die/Die.DieAttributesBuilder.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[0,"AngleTolerance",1,0],[1,"BaseFlange",0,"Section",0],[1,"BaseOrientation",0,"Die.DiePlaneBuilder",0],[0,"CreateWithPad",1,0],[1,"DeckThickness",0,"Expression",0],[1,"DieCenterlineCoordinateSystem",0,"SelectCartesianCoordinateSystem",0],[0,"DistanceTolerance",1,0],[1,"InteriorProfile",0,"Section",0],[0,"Location",1,0],[1,"MinimumRibHeight",0,"Expression",0],[1,"Offset",0,"Expression",0],[1,"PadAttributes",0,"Die.DieAttributesBuilder",0],[1,"PadHeight",0,"Expression",0],[1,"PadWidth",0,"Expression",0],[1,"PlacementOffset",0,"Expression",0],[1,"RunoffDepth",0,"Expression",0],[1,"RunoffLength",0,"Expression",0],[1,"RunoffRadius",0,"Expression",0],[1,"RunoffWidth",0,"Expression",0],[1,"SheetMetal",0,"SelectNXObject",0],[1,"SlotAttributes",0,"Die.DieAttributesBuilder",0],[1,"SlotDepth",0,"Expression",0],[1,"SlotLength",0,"Expression",0],[1,"SlotWidth",0,"Expression",0],[1,"Target",0,"SelectNXObject",0],[0,"Type",1,0]],[],[]];
SPLM.Die.KeywayBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Die.KeywayBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Die.KeywayBuilder.Types = Object.freeze({
    "Rectangular" : "Rectangular", "Circular" : "Circular"});

SPLM.Die.KeywayBuilder.LocationType = Object.freeze({
    "PositiveX" : "PositiveX", "NegativeX" : "NegativeX", "PositiveY" : "PositiveY", "NegativeY" : "NegativeY"});

export default SPLM;